var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 22.8406C13.9067 24.3469 12.652 25.1 11.1458 25.1C9.63953 25.1 8.38482 24.3469 7.38015 22.8406M18.8051 20.5813H3.4865C3.04643 20.5815 2.61419 20.4648 2.23397 20.2432C1.85375 20.0217 1.53918 19.7031 1.32242 19.3201C1.10565 18.9372 0.994461 18.5035 1.00021 18.0635C1.00596 17.6234 1.12845 17.1928 1.35515 16.8156C2.83343 14.3518 3.61438 11.5326 3.61453 8.65928V7.025C3.61453 5.42707 4.2493 3.89459 5.37921 2.76468C6.50911 1.63478 8.0416 1 9.63953 1H12.652C14.25 1 15.7824 1.63478 16.9123 2.76468C18.0422 3.89459 18.677 5.42707 18.677 7.025V8.65928C18.677 11.5317 19.4573 14.3529 20.9364 16.8156C21.1631 17.1928 21.2856 17.6234 21.2913 18.0635C21.2971 18.5035 21.1859 18.9372 20.9691 19.3201C20.7524 19.7031 20.4378 20.0217 20.0576 20.2432C19.6774 20.4648 19.2451 20.5815 18.8051 20.5813Z",
    stroke: "black",
    strokeOpacity: 0.45,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNotificationIcon);
export default __webpack_public_path__ + "static/media/headerNotificationIcon.226a7697c3dfd9276cc748bfbfb7786c.svg";
export { ForwardRef as ReactComponent };